import {
    Button,
    ButtonKind,
    Footer,
    Status,
    StatusType,
} from '../../../shared/ModalV2';
import { ModalV2 } from '../../../shared/ModalV2/ModalV2.tsx';

import { IapExportResult } from '../../../hooks/packs.ts';

import { ApiAvailableStore } from '../../../types/enums/store.enum.ts';

import styles from './PackExportResultsModal.module.scss';

const StoreToTextMap: Record<ApiAvailableStore, string> = {
    [ApiAvailableStore.GOOGLE]: 'Google Play Store',
    [ApiAvailableStore.APPLE]: 'Apple Store',
};

type PackExportResultsModalProps = {
    store: ApiAvailableStore;
    exportResults: IapExportResult[];
    onClose: () => void;
    onRetry: () => void;
};

export const PackExportResultsModal = (props: PackExportResultsModalProps) => {
    const { exportResults, store, onClose, onRetry } = props;

    const { exported, skipped, failed } = exportResults.reduce<{
        exported: IapExportResult[];
        skipped: IapExportResult[];
        failed: IapExportResult[];
    }>(
        (memo, result) => {
            if (result.error) {
                memo.failed.push(result);
            } else if (result.skipped) {
                memo.skipped.push(result);
            } else {
                memo.exported.push(result);
            }

            return memo;
        },
        { exported: [], skipped: [], failed: [] },
    );

    return (
        <ModalV2 className={styles.resultsModal}>
            <>
                {exported.length > 0 && (
                    <>
                        <Status
                            type={StatusType.Info}
                            header={`The following IAPs were exported to ${StoreToTextMap[store]}`}
                            className={styles.status}
                        />
                        {exported.map((result) => (
                            <p key={result.productId}>
                                <a
                                    href={result.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {result.productId}
                                </a>
                            </p>
                        ))}
                    </>
                )}
                {failed.length > 0 && (
                    <>
                        <Status
                            type={StatusType.Error}
                            header={`The following IAPs failed to export ${StoreToTextMap[store]}`}
                            className={styles.status}
                        />
                        {failed.map((result) => (
                            <p key={result.productId}>
                                <div>{result.productId}</div>
                                <div className={styles.errorMessage}>
                                    {result.error}
                                </div>
                            </p>
                        ))}
                    </>
                )}
                {skipped.length > 0 && (
                    <>
                        <Status
                            type={StatusType.Warning}
                            header={'The following IAPs were skipped'}
                            className={styles.status}
                        />
                        {skipped.map((result) => (
                            <p key={result.productId}>{result.productId}</p>
                        ))}
                    </>
                )}
                <Footer>
                    <Button kind={ButtonKind.SECONDARY} onClick={onClose}>
                        Close
                    </Button>
                    {failed.length > 0 && (
                        <Button kind={ButtonKind.PRIMARY} onClick={onRetry}>
                            Retry
                        </Button>
                    )}
                </Footer>
            </>
        </ModalV2>
    );
};
